<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">


        <!-- 操作按钮区域 -->
        <el-row class="table-header">
          <el-col>
            <div class="action-buttons">
              <el-button 
                type="primary" 
                size="medium" 
                icon="el-icon-upload2" 
                @click="triggerFileUpload" 
                :disabled="loadingStaus"
                class="action-btn">
                <span>导入费用</span>
              </el-button>
              <input type="file" accept=".xlsx" ref="fileInput" @change="handleFileUpload" style="display: none;" />
              
              <el-button 
                type="success" 
                size="medium" 
                icon="el-icon-download" 
                @click="downloadButton()"
                class="action-btn">
                <span>导出费用</span>
              </el-button>
              
              <el-tooltip effect="dark" content="添加新的区域费用配置" placement="top">
                <el-button 
                  type="primary" 
                  size="medium" 
                  icon="el-icon-plus" 
                  @click="addButton()"
                  class="action-btn add-btn">
                  <span>添加费用</span>
                </el-button>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>

        <!-- 搜索区域 -->
        <div class="search-section">
          <el-card shadow="never" class="search-card">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item label="区域名称" class="search-item">
                <el-input 
                  v-model="searchCondition.zone" 
                  placeholder="请输入区域名称" 
                  clearable
                  prefix-icon="el-icon-location"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="包含国家" class="search-item">
                <el-input 
                  v-model="searchCondition.countries" 
                  placeholder="请输入国家名称" 
                  clearable
                  prefix-icon="el-icon-map-location"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="重量(kg)" class="search-item">
                <el-input 
                  v-model="searchCondition.weight" 
                  placeholder="请输入重量" 
                  clearable
                  prefix-icon="el-icon-scale-to-original"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item class="search-actions">
                <el-button 
                  type="primary" 
                  @click="getList"
                  icon="el-icon-search"
                  class="search-btn">
                  查询
                </el-button>
                <el-button 
                  type="danger" 
                  @click="deleteBatchButton"
                  icon="el-icon-delete"
                  class="batch-delete-btn">
                  批量删除
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-section">
          <el-card shadow="never" class="table-card">
            <ApeTable 
              ref="apeTable" 
              :data="dataList"  
              :loading="loadingStaus" 
              :pagingData="pagingData" 
              @switchPaging="switchPaging" 
              highlight-current-row 
              border
              class="data-table">
              
              <el-table-column
                label="到达地区"
                prop="zone"
                min-width="150"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="zone-cell">
                    <i class="el-icon-location-outline cell-icon"></i>
                    <span class="zone-text">{{scope.row.zone}}</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="到达国家"
                prop="countries"
                min-width="200"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="countries-cell">
                    <i class="el-icon-map-location cell-icon"></i>
                    <span class="countries-text">{{scope.row.countries}}</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="重量范围"
                width="140"
                align="center">
                <template slot-scope="scope">
                  <div class="weight-cell">
                    <el-tag size="small" type="info">{{scope.row.weight}}kg</el-tag>
                    <span v-if="scope.row.is_phase==1" class="weight-range">
                      <i class="el-icon-right"></i>
                      <el-tag size="small" type="warning">{{scope.row.end_weight}}kg</el-tag>
                    </span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="计费类型"
                width="100"
                align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.is_phase==1 ? 'success' : 'primary'" size="small">
                    {{scope.row.is_phase==1 ? '阶段计费' : '固定计费'}}
                  </el-tag>
                </template>
              </el-table-column>
              
              <el-table-column
                label="费用配置"
                width="150"
                align="center">
                <template slot-scope="scope">
                  <div class="price-cell">
                    <div class="price-item">
                      <span class="price-label">{{scope.row.is_phase==0 ? '总价:' : '单价:'}}</span>
                      <span class="price-value">¥{{scope.row.price}}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="忙时费率"
                width="100"
                align="center">
                <template slot-scope="scope">
                  <el-tag size="small" type="danger">{{scope.row.busy_date_rate}}</el-tag>
                </template>
              </el-table-column>
              
              <el-table-column
                label="忙时日期"
                min-width="180"
                align="center">
                <template slot-scope="scope">
                  <div class="busy-dates-cell">
                    <div v-for="(item,index) in JSON.parse(scope.row.busy_dates)" :key="index" class="date-range">
                      <el-tag size="mini" type="warning">{{item.dateRange[0]}}~{{item.dateRange[1]}}</el-tag>
                    </div>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right">
                <template slot-scope="scope">
                  <div class="operation-buttons">
                    <el-tooltip effect="dark" content="编辑费用配置" placement="top">
                      <el-button 
                        size="mini" 
                        type="primary"
                        icon="el-icon-edit" 
                        @click="editButton(scope.row.id)"
                        class="op-btn">
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </ApeTable>
          </el-card>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 编辑弹窗 -->
    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <div class="form-container">
          <el-form 
            :model="formData" 
            :rules="rules" 
            ref="dataForm" 
            label-position="left" 
            label-width="100px"
            class="drawer-form">
            
            <el-form-item label="到达地区" prop="zone">
              <el-input 
                v-model="formData.zone"
                placeholder="请输入到达地区名称"
                prefix-icon="el-icon-location">
              </el-input>
            </el-form-item>
            
            <el-form-item label="包含国家" prop="countries">
              <el-select 
                v-model="formData.countries" 
                clearable 
                placeholder="请选择目的地国家" 
                multiple  
                collapse-tags
                class="full-width">
                <el-option
                  v-for="item in countryList"
                  :key="item.address_name"
                  :label="item.address_name"
                  :value="item.address_name">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="计费方式" prop="is_phase">
              <el-select v-model="formData.is_phase" clearable placeholder="请选择计费方式">
                <el-option label="固定计费" value="0"></el-option>
                <el-option label="阶段计费" value="1"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="起始重量" prop="weight">
              <el-input 
                v-model="formData.weight" 
                type="number"
                placeholder="请输入起始重量(kg)"
                prefix-icon="el-icon-scale-to-original">
              </el-input>
            </el-form-item>
            
            <el-form-item label="结束重量" prop="end_weight" v-if="formData.is_phase==1">
              <el-input 
                v-model="formData.end_weight" 
                type="number"
                placeholder="请输入结束重量(kg)"
                prefix-icon="el-icon-scale-to-original">
              </el-input>
            </el-form-item>
            
            <el-form-item label="价格配置" prop="price">
              <el-input 
                v-model="formData.price" 
                type="number"
                placeholder="请输入价格"
                prefix-icon="el-icon-money">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            
            <el-form-item label="忙时费率" prop="busy_date_rate">
              <el-input 
                v-model="formData.busy_date_rate" 
                type="number"
                placeholder="请输入忙时费率"
                prefix-icon="el-icon-timer">
              </el-input>
            </el-form-item>
            
            <el-form-item label="忙时日期">
              <div class="busy-dates-config">
                <div class="add-date-btn">
                  <el-button 
                    type="primary" 
                    size="small"
                    icon="el-icon-plus" 
                    @click="addItem"
                    plain>
                    添加忙时日期
                  </el-button>
                </div>
                
                <el-table :data="formData.busy_dates" stripe class="date-table">
                  <el-table-column prop="start_date" label="日期范围">
                    <template slot-scope="scope">
                      <el-date-picker 
                        v-model="scope.row.dateRange" 
                        type="daterange" 
                        range-separator="至" 
                        start-placeholder="开始日期" 
                        end-placeholder="结束日期" 
                        format="MM-dd" 
                        value-format="MM-dd">
                      </el-date-picker>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <el-button 
                        size="mini" 
                        type="danger"
                        icon="el-icon-delete" 
                        @click="deleteItem(scope.$index)"
                        class="delete-date-btn">
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx';
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        query: "",
        params: [],
        zone: '',
        countries: '',
        weight: '',
      },
      countryList:[],
      loadingStaus: false,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        page_size: 20,
        current_page: 1,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      express_detail:{},
      // 表单结构
      formData: {
        id:'',
        busy_dates:[],
        is_phase:"0",
      },
      // 表单验证
      rules: {
        zone: [{required: true,message:'输入区域', trigger: 'blur' }],
        countries: [{required: true,message:'输入包含国家', trigger: 'blur' }],
        is_phase: [{required: true,message:'选择是否阶段计费', trigger: 'blur' }],
        weight: [{required: true,message:'输入重量', trigger: 'blur' }],
        end_weight: [{required: true,message:'输入结束重量', trigger: 'blur' }],
        price: [{required: true,message:'输入价格', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '50%',
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    number(value){
      if(isNaN(value)) { value = 0.00 } if(value.indexOf('.')>0){value=parseFloat(value.slice(0,value.indexOf('.')+2))}
      return parseFloat(value)
    },
    addItem() {
      this.formData.busy_dates.push({no:this.formData.busy_dates.length+1})
    },
    randomString(length) {
      return Math.random().toString(36).substring(2, length + 2);
    },
    deleteItem(item){
      this.formData.busy_dates.splice(item,1)
    },
    // 搜索
    setSearchCondition() {
      this.loadingStaus=true
      this.searchCondition.query= 'express_id=?'
      this.searchCondition.params = [this.$route.params.id]
      if (this.searchCondition.zone != '' && this.searchCondition.zone != null){
        this.searchCondition.query += ' and instr(zone,?)>0'
        this.searchCondition.params.push(this.searchCondition.zone)
      } 
      if (this.searchCondition.weight != '' && this.searchCondition.weight != null){
        this.searchCondition.query += ' and weight=?'
        this.searchCondition.params.push(this.searchCondition.weight)
      }
      if (this.searchCondition.countries != '' && this.searchCondition.countries != null){
        this.searchCondition.query += ' and find_in_set(?,countries)>0'
        this.searchCondition.params.push(this.searchCondition.countries)
      }
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    // 响应添加按钮
    async addButton() {
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
      this.formData.id = ''
      this.formData.busy_dates = []
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(UID：'+id+')'
      let res = await this.$api.post('/service/ola_app_express_zones/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
        this.formData.busy_dates = JSON.parse(this.formData.busy_dates)
        this.formData.countries = this.formData.countries.split(',')
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      this.formData.express_id = this.$route.params.id
      this.formData.countries = this.formData.countries.join(',')
      if(this.formData.busy_dates.length>0){
        this.formData.busy_dates = JSON.stringify(this.formData.busy_dates)
      }
      let url = '/service/ola_app_express_zones/create'
      if(this.formData.id!=''){
        url = '/service/ola_app_express_zones/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initFormData()
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
      this.drawerData.visible = false
      this.getList()
    },
    // 批量删除
    async deleteBatchButton() {
      this.loadingStaus = true
      this.setSearchCondition()
      let res = await this.$api.post('/service/ola_app_express_zones/delete_batch',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.$message.success('删除成功!')
        this.getList()
      }else{
        this.$message.error(res.message)
      }
      this.loadingStaus = false
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let res = await this.$api.post('/service/ola_app_express_zones/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initFormData()
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
      this.drawerData.visible = false
      this.getList()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.post('/service/ola_app_express_zones/delete',{id:id})
      if (info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async getList() {
      this.setSearchCondition()
      Object.assign(this.searchCondition,this.$refs['apeTable'].getPagingInfo())
      let res= await this.$api.post('/service/ola_app_express_zones/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList=res.data.list
        this.pagingData.total = res.data.page.total
      }else{
        this.dataList=[]
        this.pagingData.total = 0
      }
      this.loadingStaus=false
    },
    triggerFileUpload() {
      this.loadingStaus = true
      this.$refs.fileInput.click(); // 触发文件输入的点击事件
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          // 处理工作簿内容
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          this.importData(jsonData)
        };
        reader.readAsArrayBuffer(file);
      }
    },
    async importData(jsonData) {
      console.log(jsonData)
      let datas = jsonData.map(item => ({
          "express_id": this.$route.params.id,
          "zone": item.区域,
          "countries": item.包含国家,
          "weight": item.开始重量,
          "end_weight": item.结束重量,
          "is_phase": item.是否阶段计费=='是'?'1':'0',
          "price": item.价格,
          "busy_date_rate": item.忙时费率,
          "zone_status": "1",
          "busy_dates": item.忙时日期
      }));
      let res = await this.$api.post('/service/ola_app_express_zones/import',{datas:datas,unique_key:"express_id,zone,countries"})
      if (this.$apiSuccess(res)){
        this.$message.success('导入成功!')
        this.getList()
      }else{
        this.$message.error(res.message)
      }
      this.loadingStaus = false
    },
    async downloadButton() {
      let res = await this.$api.post('/service/ola_app_express_zones/list',{express_id:this.$route.params.id})
      if (this.$apiSuccess(res)){
        let data = res.data.list
        const filteredData = data.map(item => ({
          "区域": item.zone,
          "包含国家": item.countries,
          "开始重量": item.weight,
          "结束重量": item.end_weight,
          "是否阶段计费": item.is_phase==1?'是':'否',
          "价格": item.price,
          "忙时费率": item.busy_date_rate,
          "忙时日期": item.busy_dates
        }));
        // 生成 Excel
        const worksheet = XLSX.utils.json_to_sheet(filteredData, {
          header: ["区域", "开始重量", "结束重量", "是否阶段计费", "价格", "忙时费率", "忙时日期"],
          skipEmpty: false
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "快递费用");
        // 导出 Excel 文件
        XLSX.writeFile(workbook, "快递费用.xlsx");
      }
    },
    async getCountryList() {
      let searchCondition = {
        query: 'pid=?',
        params: ["0"]
      }
      let res = await this.$api.post('/service/ola_app_arrive_address/list',searchCondition)
      if (this.$apiSuccess(res)){
        this.countryList=res.data.list
      }else{
        this.countryList=[]
      }
    },
  },
  mounted() {
    this.getList()
    this.getCountryList()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题样式
.page-title-section
  margin-bottom 24px
  padding 16px 0
  border-bottom 1px solid #E4E7ED
  
  .page-title
    font-size 24px
    font-weight 600
    color #303133
    margin 0 0 8px 0
    
  .page-subtitle
    font-size 14px
    color #909399
    margin 0

// 操作按钮区域样式
.table-header
  margin-bottom 16px
  
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      display flex
      align-items center
      gap 8px
      padding 10px 16px
      border-radius 6px
      transition all 0.3s ease
      
      &:hover
        transform translateY(-1px)
        box-shadow 0 4px 12px rgba(0,0,0,0.15)
        
    .add-btn
      background linear-gradient(135deg, #409EFF 0%, #67C23A 100%)
      border none
      
      &:hover
        background linear-gradient(135deg, #337ecc 0%, #529b2e 100%)

// 搜索区域样式
.search-section
  margin-bottom 16px
  
  .search-card
    border-radius 8px
    box-shadow 0 2px 8px rgba(0,0,0,0.1)
    
    .search-form
      .search-item
        margin-right 24px
        margin-bottom 0
        
        .search-input
          width 180px
          
      .search-actions
        margin-right 0
        
        .search-btn
          background #409EFF
          border-color #409EFF
          padding 8px 20px
          
        .batch-delete-btn
          margin-left 8px
          padding 8px 16px

// 表格区域样式  
.table-section
  .table-card
    border-radius 8px
    box-shadow 0 2px 8px rgba(0,0,0,0.1)
    
    .data-table
      /deep/ .el-table
        border-radius 8px
        overflow hidden
        
        th
          background #F5F7FA
          color #606266
          font-weight 600
          
        .zone-cell, .countries-cell
          display flex
          align-items center
          gap 8px
          
          .cell-icon
            color #409EFF
            font-size 14px
            
          .zone-text, .countries-text
            color #303133
            
        .weight-cell
          display flex
          flex-direction column
          gap 4px
          
          .weight-range
            display flex
            align-items center
            gap 4px
            
        .price-cell
          .price-item
            display flex
            flex-direction column
            gap 2px
            
            .price-label
              font-size 12px
              color #909399
              
            .price-value
              font-weight 600
              color #E6A23C
              
        .busy-dates-cell
          display flex
          flex-direction column
          gap 4px
          
          .date-range
            margin-bottom 2px
            
        .operation-buttons
          display flex
          gap 8px
          justify-content center
          
          .op-btn
            padding 4px 8px
            border-radius 4px
            
            &:hover
              transform scale(1.1)

// 抽屉表单样式
.form-container
  padding 20px
  
  .drawer-form
    /deep/ .el-form-item
      margin-bottom 24px
      
      .el-form-item__label
        font-weight 600
        color #606266
        
      .el-input, .el-select
        .el-input__inner
          border-radius 6px
          border-color #DCDFE6
          transition all 0.3s ease
          
          &:focus
            border-color #409EFF
            box-shadow 0 0 0 2px rgba(64,158,255,0.2)
            
    .full-width
      width 100%
      
    .busy-dates-config
      .add-date-btn
        margin-bottom 16px
        
      .date-table
        border-radius 6px
        overflow hidden
        
        .delete-date-btn
          padding 4px 8px
</style>
